import { RandomLayerGroupSelectionProps } from 'business/models/CustomModels';
import React from 'react';
import { ReactComponent as Delete } from 'Icons/Sidebar/Delete.svg';
import './GroupSelection.scss';
import { useIsScreenInUse } from 'redux/hooks/common';

export default function GroupSelection({
  name,
  probability,
  id,
  setActiveGroup,
  deleteGroup,
  active = true,
  isEditMode = true,
}: RandomLayerGroupSelectionProps) {
  const isScreenInUse: boolean = useIsScreenInUse();

  function onClick(e) {
    setActiveGroup(id);
  }
  function getNameAndProbability() {
    if (probability !== null) {
      return (
        <>
          <b>{name}</b>
          <br />
          Probability: {probability}
        </>
      );
    }
    return (
      <>
        <b id={`commandpanel-randomlayering-groupselection-${name}`}>{name}</b>
      </>
    );
  }
  function getDeleteButton() {
    if (active && isEditMode && !isScreenInUse) {
      return <Delete id={`commandpanel-randomlayering-groupselection-delete-button`} className="deleteButton" onClick={(e) => deleteGroup(id)} />;
    }
  }
  return (
    <div id={`commandpanel-randomlayering-groupselection-wrapper`}
      onClick={onClick}
      className={`group-selection-parent flex flex-column flex-y-center flex-space-between ${
        !active && 'inactive-groups-selection'
      } ${active && 'active-groups-selection'}`}
    >
      {getDeleteButton()}
      <div id="commandpanel-randomlayering-groupselection-text" className="layer-selection-text groupText">{getNameAndProbability()}</div>
    </div>
  );
}
